/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SelectRange, {FIELD_NAME} from '@adv-mt/mt-form-select-range'

const LEGACY_WRAPPER = 'legacy'

const FormDoorsRange = ({
  initialSearch,
  isInline,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = {},
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {doors, DEFAULT_DOORS_MIN = 0, FILTER_NAMES} = config.get('search')

  const currentValue = {
    from: value.from || DEFAULT_DOORS_MIN,
    to: value.to || DEFAULT_DOORS_MIN
  }

  const options = useMemo(
    () =>
      doors.map(({id, label}) => ({
        id: Number(id),
        label: `${label} ${i18n.t('COMMON.DOORS').toLowerCase()}`
      })),
    []
  )

  return (
    <SelectRange
      fieldName={FILTER_NAMES.DOOR}
      formatterLabel={({value}) => `${value} ${i18n.t('COMMON.DOORS').toLowerCase()}`}
      initialSearch={initialSearch}
      isInline={isInline}
      label={i18n.t('COMMON.DOORS')}
      onChange={onChange}
      options={{
        from: {
          name: FIELD_NAME.FROM,
          options
        },
        to: {
          name: FIELD_NAME.TO,
          options
        }
      }}
      overlayContentRef={overlayContentRef}
      pageName={pageName}
      type={type}
      value={currentValue}
      wrapper={wrapper}
    />
  )
}

const FormDoorsRangeInline = props => <FormDoorsRange {...props} isInline />
FormDoorsRangeInline.displayName = 'FormDoorsRangeInline'

FormDoorsRange.displayName = 'FormDoorsRange'
FormDoorsRange.propTypes = {
  initialSearch: PropTypes.object,
  isInline: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.object,
  wrapper: PropTypes.string
}

export {FormDoorsRangeInline}

export default FormDoorsRange
